import React, { ReactElement } from 'react';
import { truncateText } from 'common/utils/string.utils';

export const TruncateText = ({
  children: text,
  length,
  indicator = '...',
  truncateFn = truncateText,
}: {
  children: string;
  length: number;
  indicator?: string;
  truncateFn?: (text: string, length: number, indicator: string) => string;
}): ReactElement => <>{truncateFn(text, length, indicator)}</>;
